import { render } from "./IncongruityListPage.vue?vue&type=template&id=7be305cf"
import script from "./IncongruityListPage.vue?vue&type=script&lang=js"
export * from "./IncongruityListPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__